import { styled } from '@components-shared/src/stitches';

export const SeatingGrid = styled('div', {
  display: 'grid',
  overflow: 'visible',
  width: '100%',
  gap: 8,
  gridTemplateColumns: `repeat(24, 1fr)`,
  '.first': {
    gridColumn: 'span 8',
  },
  '.mid': {
    gridColumn: 'span 6',
  },

  '@tablet': {
    gap: 12,
    '.mid': {
      gridColumn: 'span 4',
    },
  },
});

export const Seat = styled('div', {
  position: 'relative',
  background: '$neutral100',
  borderRadius: '8px',
  aspectRatio: '1/1',
  height: 'auto',
  width: '100%',
  gridColumn: 'span 3',

  img: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
  },

  '&:hover': {
    cursor: 'pointer',
    lift: 'secondary',
  },

  '@tablet': {
    gridColumn: 'span 2',
  },

  variants: {
    empty: {
      true: {
        '&:hover': {
          cursor: 'default',
          boxShadow: 'unset',
        },
      },
    },
  },
});

export const GoldenEggContainer = styled('div', {
  position: 'absolute',
  width: 45,
  height: 45,
  top: -20,
  zIndex: '$above1',

  '@tablet': {
    width: 50,
    height: 50,
  },

  variants: {
    row: {
      first: {
        right: 4,
        '@tablet': {
          right: 8,
        },
      },
      mid: {
        right: 4,
      },
      last: {
        width: 30,
        height: 30,
        top: -10,
        right: 0,
      },
    },
  },
});
